// const formatter = new Intl.NumberFormat('en-US');

// eslint-disable-next-line max-len
const numberFormat = (value = 0, withCurrency = false, withDecimal = true) => `${withCurrency ? 'Rp ' : ''}${(parseFloat((value || 0).toString()))
  .toLocaleString('id-ID', { maximumFractionDigits: withDecimal ? 2 : 0 })}`;

export default numberFormat;
